module.exports = __webpack_public_path__ + "img/bgBox_sp.21f6fade.jpg";